import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider, useSearchParams } from "react-router-dom";
import App from "./components/App";
import Home from "./components/Home";
import ShowsList from "./components/ShowsList";
import Show from "./components/Show";
import NoMatch from "./components/NoMatch";
import FlowerShooterGame from "./components/FlowerShooterGame";

const GameRoute = () => {
  const [params] = useSearchParams();
  return <FlowerShooterGame mapName={params.get("map") || undefined} />;
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <Home /> },
      { path: "shows", element: <ShowsList /> },
      { path: "shows/:showId", element: <Show /> },
      { path: "game", element: <GameRoute /> },
      { path: "*", element: <NoMatch /> },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <RouterProvider
    router={router}
    future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
  />
);
